export default __webpack_public_path__ + "static/media/btn_left_arrow.5bdc9e72.svg";